module.exports = __webpack_public_path__ + "static/media/2 (34).620d4e42.jpg";